import { Component, OnInit } from '@angular/core';

import { DataService } from 'app/infrastructure/services/base/config/data.service';

// import  '../../common/date-formatted';
// import { toFormatDatePicker } from '../../../common/date-formatted-func';

declare var jQuery: any;
@Component({
    selector: 'invoice-report',
    templateUrl: './invoice-report.html',
    providers: [DataService],
    styles: [`
        .input-group{
            border-spacing: 0; border-collapse: separate;
        }
        .input-group-addon{
            padding: 0 12px !important;
        }
    `]

})
export class InvoiceReportComponent implements OnInit {
    
    arrCboAccounts: any[] = [];
    arrCboOrderTypes: any[] = ['Repeat Order', 'Release Order'];
    arrCboFormat: any[] = ['PDF', 'XLS', 'CSV'];

    constructor(private dtService: DataService) { }
    ngOnInit(): void {
        this.getAccounts();
    }
    getAccounts(): void {
        this.dtService.getJSON("../../../assets/mock-data/account.json")
            .subscribe(
            data => this.arrCboAccounts = data.Account,
            error => console.log(error),
            // () => console.log("Finished Call Accounts") 
        );
    }
    ngAfterViewInit() {
        // var format=toFormatDatePicker("dd/mm/yyyy");
        // jQuery('.mydatepicker').datepicker({
        //     autoclose: true,
        //     clearBtn: true,
        //     format: format
        // }).on('change', (e) => {
        //     // if(e.target.value!=""){
        //     //     var d = new Date(e.target.value);
        //     //     e.target.value=d.format('dd-MM-yyyy');
        //     // }
        //     //this.search[e.target.name] = e.target.value;
        // });

    }

    showDatePicker(idEl) {
        jQuery('#' + idEl).datepicker('show');
    }

}


// WEBPACK FOOTER //
// ./src/app/views/pages/transaction/reports/invoice-report/invoice-report.component.ts